module.exports = __webpack_public_path__ + "static/media/fasad.bea50a15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Contacts/components/Contacts/images/fasad.jpg
// module id = 704
// module chunks = 0